import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SubscriptionSettings } from '../../../../SideBar/SettingsModal/SubscriptionSettings';
import './SubscriptionSection.scss';

const SubscriptionSection: FC = () => {
  const { t } = useTranslation();

  return (
    <Stack gap={2} className="subscription-section">
      <Typography variant="h3" className="subscription-section__title">
        {t('settings.nav.subscription')}
      </Typography>

      <div className="subscription-section__block">
        <SubscriptionSettings showAccountActions={false} />
      </div>
    </Stack>
  );
};

export default SubscriptionSection;
